import API from './axios.js';

export const getHierarchy = (queryParams = '') => API.get(`auth/hierarchy${queryParams}`);